// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__27HeJ","iconWrapper":"styles_iconWrapper__16JEz","label":"styles_label__TYOwB","subtitle":"styles_subtitle__fH49K"};